import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { BrowserMultiFormatReader, DecodeHintType, BarcodeFormat } from '@zxing/library';
import axios from 'axios';
import './style.css';

import { MdAutorenew } from "react-icons/md";
import { RiBarcodeBoxLine } from "react-icons/ri";
import { MdOutlineSearch, MdArrowBack, MdClose, MdPerson } from "react-icons/md";

import { fileApiUrl } from '../../../config/apiConfig';
import apiUploads from '../../../services/apiUploads';

function FaktoryPage() {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const modoLocal = searchParams.get('modo') === 'local';

  const [code, setCode] = useState('');
  const [variant, setVariant] = useState('');
  const [quantity, setQuantity] = useState('');
  const [productInfo, setProductInfo] = useState(null);
  const [scanning, setScanning] = useState(false);
  const [facingMode, setFacingMode] = useState('environment');
  const [isProcessing, setIsProcessing] = useState(false);
  const [isScanned, setIsScanned] = useState(false);
  const [modalUsuarioAberto, setModalUsuarioAberto] = useState(false);
  const [buscaModalUsuario, setBuscaModalUsuario] = useState('');
  const [usuariosModal, setUsuariosModal] = useState([]);
  const [buscandoUsuariosModal, setBuscandoUsuariosModal] = useState(false);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  
  // Estados para o novo modal de movimentação com local de estoque
  const [modalLocalEstoqueAberto, setModalLocalEstoqueAberto] = useState(false);
  const [localEstoqueSelecionado, setLocalEstoqueSelecionado] = useState('');
  const [quantidadeLocalEstoque, setQuantidadeLocalEstoque] = useState('');
  const [isProcessingLocalEstoque, setIsProcessingLocalEstoque] = useState(false);

  const videoRef = useRef(null);
  const codeReaderRef = useRef(null);
  const hasScannedRef = useRef(false);
  
  // Refs para prevenir chamadas duplicadas
  const isSubmittingLocalEstoqueRef = useRef(false);
  const isSubmittingNormalRef = useRef(false);

  useEffect(() => {
    setProductInfo(null);
    setQuantity('');
  }, [code, variant]);

  useEffect(() => {
    // Carregar usuário selecionado do localStorage ao montar
    const usuarioSalvo = localStorage.getItem('usuarioSelecionado');
    if (usuarioSalvo) {
      try {
        setUsuarioSelecionado(JSON.parse(usuarioSalvo));
      } catch (error) {
        console.error('Erro ao carregar usuário do localStorage:', error);
      }
    }
  }, []);

  useEffect(() => {
    if (code && isScanned && !isProcessing) {
      fetchProduct();
      setIsScanned(false);
    }
  }, [code, variant, isScanned]);

  const startScanner = async () => {
    const hints = new Map();
    hints.set(DecodeHintType.POSSIBLE_FORMATS, [BarcodeFormat.QR_CODE]);

    const codeReader = new BrowserMultiFormatReader(hints);
    codeReaderRef.current = codeReader;
    hasScannedRef.current = false;

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode,
          width: { ideal: 640 },
          height: { ideal: 640 }
        }
      });

      const video = videoRef.current;
      video.srcObject = stream;

      await new Promise((resolve) => {
        video.onloadedmetadata = () => {
          video.play();
        };
        video.oncanplay = () => {
          // Espera 300ms para estabilizar a imagem antes de iniciar leitura
          setTimeout(resolve, 300);
        };
      });

      console.log('Iniciando leitura contínua com decodeFromVideoDevice...');

      codeReader.decodeFromVideoDevice(null, video, (result, err) => {
        if (result && !hasScannedRef.current) {
          hasScannedRef.current = true;

          const scannedData = result.getText();
          const [scannedCode, scannedVariant] = scannedData.split('|');

          console.log('QR code detectado:', scannedData);

          codeReader.reset();
          stopCamera();

          setCode(scannedCode || '');
          setVariant(scannedVariant || '');
          setIsScanned(true);
        }

        // Ignora erros de leitura comuns
        if (err && err.name !== 'NotFoundException' && err.name !== 'ChecksumException' && err.name !== 'FormatException') {
          console.error('Erro ao escanear:', err);
          // NÃO para a câmera, só loga
        }
      });


    } catch (err) {
      console.error('Erro ao acessar a câmera:', err);
      alert(`Erro ao acessar a câmera: ${err.message}`);
      stopCamera();
    }
  };






  const stopCamera = () => {
    const stream = videoRef.current?.srcObject;
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      videoRef.current.srcObject = null;
    }
    if (codeReaderRef.current) {
      codeReaderRef.current.reset();
    }
    setScanning(false);
  };

  const toggleCamera = () => {
    setFacingMode((prevMode) => (prevMode === 'environment' ? 'user' : 'environment'));
  };

  const fetchProduct = async () => {
    if (!code) {
      alert('Por favor, informe ou escaneie um código antes de buscar');
      return;
    }

    const fullCode = variant ? `${code}|${variant}` : code;
    setIsProcessing(true);
    try {
      // Se estiver no modo Wolff, usa o endpoint específico para o local 52997
      const endpoint = modoLocal 
        ? `/faktory/stock/product-wolff/${fullCode}`
        : `/faktory/stock/product/${fullCode}`;
      
      console.log(`📦 Buscando produto ${modoLocal ? '(Wolff)' : '(Normal)'}:`, fullCode);
      
      const response = await apiUploads.get(endpoint);
      console.log('Resposta da API:', response.data);
      if (response.status === 200) {
        const product = response.data;
        const newProductInfo = {
          code: product.code,
          name: product.name || 'Não informado',
          variant: product.variant || 'Não informado',
          group: product.group || 'Não informado',
          quantity: product.quantity || 0,
          idProduto: product.ID_PRODUTO,
          idProdutoVariante: product.ID_PRODUTOVARIANTE,
          unidade: product.unidade,
        };
        setProductInfo(newProductInfo);
        
        // Se estiver no modo local, abre o modal automaticamente
        if (modoLocal) {
          setModalLocalEstoqueAberto(true);
          setLocalEstoqueSelecionado('');
          setQuantidadeLocalEstoque('');
        }
      }
    } catch (error) {
      console.error('Erro ao buscar o produto:', error);
      const mensagem = modoLocal 
        ? 'Produto não encontrado no estoque Wolff ou erro ao buscar'
        : 'Produto não encontrado ou erro ao buscar no estoque';
      alert(mensagem);
      setQuantity('');
      setProductInfo(null);
    } finally {
      setIsProcessing(false);
    }
  };

  const fetchUsuariosModal = async (termoBusca) => {
    if (!termoBusca || termoBusca.trim().length < 4) {
      return;
    }

    setBuscandoUsuariosModal(true);
    try {
      const response = await apiUploads.get('/faktory/usuarios', {
        params: { busca: termoBusca.trim() }
      });
      if (response.status === 200) {
        setUsuariosModal(response.data || []);
      }
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
      setUsuariosModal([]);
    } finally {
      setBuscandoUsuariosModal(false);
    }
  };

  const handleBuscarUsuariosModal = () => {
    fetchUsuariosModal(buscaModalUsuario);
  };

  const handleSelecionarUsuario = (usuario) => {
    setUsuarioSelecionado(usuario);
    localStorage.setItem('usuarioSelecionado', JSON.stringify(usuario));
    
    // Disparar evento customizado para atualizar outras telas
    window.dispatchEvent(new Event('usuarioSelecionadoChanged'));
    
    setModalUsuarioAberto(false);
    setBuscaModalUsuario('');
    setUsuariosModal([]);
  };

  const handleAbrirModalUsuario = () => {
    setModalUsuarioAberto(true);
    setBuscaModalUsuario('');
    setUsuariosModal([]);
  };

  const handleFecharModalUsuario = () => {
    setModalUsuarioAberto(false);
    setBuscaModalUsuario('');
    setUsuariosModal([]);
  };

  // const handleCodeSubmit = async (tipo) => {
  //   const enteredQuantity = parseInt(quantity, 10);
  //   const stockQuantity = productInfo?.quantity || 0;

  //   if (isNaN(enteredQuantity) || enteredQuantity <= 0) {
  //     alert('Por favor, insira uma quantidade válida maior que 0.');
  //     return;
  //   }

  //   if (enteredQuantity > stockQuantity) {
  //     alert(`Quantidade informada (${enteredQuantity}) é maior que a quantidade em estoque (${stockQuantity}).`);
  //     return;
  //   }

  //   setIsProcessing(true);
  //   try {
  //     const payload = {
  //       tpEntradaSaida: tipo,
  //       idProduto: productInfo.idProduto,
  //       idProdutoVariante: productInfo.idProdutoVariante,
  //       quantity: enteredQuantity,
  //     };
  //     const response = await axios.post(`${fileApiUrl}/faktory/stock/update-quantity`, payload);
  //     if (response.status === 200 || response.status === 201) {
  //       alert('Estoque atualizado com sucesso!');
  //       setQuantity('');
  //       fetchProduct();
  //     }
  //   } catch (error) {
  //     console.error('Erro ao atualizar o estoque:', error);
  //     alert(`Erro ao atualizar o estoque: ${error.response?.data?.message || error.message}`);
  //   } finally {
  //     setIsProcessing(false);
  //   }
  // };


  const handleCodeSubmit = async (tipo) => {
    // Proteção contra chamadas duplicadas usando ref (mais confiável que estado)
    if (isSubmittingNormalRef.current) {
      console.log('⚠️ Operação normal já em andamento, ignorando chamada duplicada');
      return;
    }
    
    const enteredQuantity = parseInt(quantity, 10);
    const stockQuantity = productInfo?.quantity || 0;

    // Validação: usuário deve estar selecionado
    if (!usuarioSelecionado) {
      alert('Por favor, selecione um usuário antes de realizar a operação.');
      return;
    }

    if (isNaN(enteredQuantity) || enteredQuantity <= 0) {
      alert('Por favor, insira uma quantidade válida maior que 0.');
      return;
    }

    if (enteredQuantity > stockQuantity && tipo === 1) {
      alert(`Quantidade informada (${enteredQuantity}) é maior que a quantidade em estoque (${stockQuantity}).`);
      return;
    }

    const operacao = tipo === 0 ? 'entrada' : 'saída';

    const unidadeFormatada =
      productInfo.unidade === 'BR' ? 'Barras' :
        productInfo.unidade === 'UN' ? 'Unidades' :
          productInfo.unidade === 'PC' ? 'Peças' :
            productInfo.unidade === 'M' ? 'Metros' :
              `${productInfo.unidade} unidades`;

    const confirmacao = window.confirm(
      `Deseja realmente realizar a ${operacao} de ${enteredQuantity} ${unidadeFormatada} manualmente no estoque?\n\nUsuário: ${usuarioSelecionado.DS_NOME}`
    );


    if (!confirmacao) return;

    // Marca como em processamento ANTES de qualquer operação assíncrona
    isSubmittingNormalRef.current = true;
    setIsProcessing(true);
    
    try {
      const payload = {
        tpEntradaSaida: tipo,
        idProduto: productInfo.idProduto,
        idProdutoVariante: productInfo.idProdutoVariante,
        quantity: enteredQuantity,
        idUsuario: usuarioSelecionado.ID_USUARIO,
      };
      console.log('📦 Enviando movimentação manual:', payload);
      const response = await apiUploads.post('/faktory/stock/update-quantity', payload);
      
      if (response.status === 200 || response.status === 201) {
        const data = response.data;
        
        // Verifica se houve falhas na finalização
        if (data.detalhes && data.detalhes.some(d => !d.success)) {
          const falhas = data.detalhes.filter(d => !d.success);
          const idsFalha = falhas.map(f => f.id).join(', ');
          
          alert(
            `⚠️ ATENÇÃO - FINALIZAÇÃO PENDENTE NO FAKTORY!\n\n` +
            `A movimentação foi registrada, porém NÃO FOI FINALIZADA automaticamente no Faktory.\n\n` +
            `IDs não finalizados: ${idsFalha}\n\n` +
            `➡️ AÇÃO NECESSÁRIA: Acesse o Faktory e finalize manualmente a(s) movimentação(ões) pendente(s).`
          );
        } else {
          alert('✅ Estoque atualizado e finalizado com sucesso!');
        }
        
        setQuantity('');
        fetchProduct();
      }
    } catch (error) {
      console.error('Erro ao atualizar o estoque:', error);
      alert(
        `❌ ERRO AO ATUALIZAR ESTOQUE!\n\n` +
        `${error.response?.data?.message || error.message}\n\n` +
        `⚠️ IMPORTANTE: Verifique no Faktory se a movimentação foi registrada e finalize manualmente se necessário.`
      );
    } finally {
      // Reseta o ref e o estado no finally para garantir que sempre seja executado
      isSubmittingNormalRef.current = false;
      setIsProcessing(false);
    }
  };

  // Funções para o novo modal de movimentação com local de estoque
  const handleAbrirModalLocalEstoque = () => {
    if (!productInfo) {
      alert('Por favor, busque um produto primeiro.');
      return;
    }
    setModalLocalEstoqueAberto(true);
    setLocalEstoqueSelecionado('');
    setQuantidadeLocalEstoque('');
  };

  const handleFecharModalLocalEstoque = () => {
    setModalLocalEstoqueAberto(false);
    setLocalEstoqueSelecionado('');
    setQuantidadeLocalEstoque('');
  };

  const handleSubmitLocalEstoque = async (tipo) => {
    // Proteção contra chamadas duplicadas usando ref (mais confiável que estado)
    if (isSubmittingLocalEstoqueRef.current) {
      console.log('⚠️ Operação Wolff já em andamento, ignorando chamada duplicada');
      return;
    }
    
    const enteredQuantity = parseInt(quantidadeLocalEstoque, 10);
    const stockQuantity = productInfo?.quantity || 0;

    // Validação: usuário deve estar selecionado
    if (!usuarioSelecionado) {
      alert('Por favor, selecione um usuário antes de realizar a operação.');
      return;
    }

    if (isNaN(enteredQuantity) || enteredQuantity <= 0) {
      alert('Por favor, insira uma quantidade válida maior que 0.');
      return;
    }

    if (enteredQuantity > stockQuantity && tipo === 1) {
      alert(`Quantidade informada (${enteredQuantity}) é maior que a quantidade em estoque (${stockQuantity}).`);
      return;
    }

    const operacao = tipo === 0 ? 'entrada' : 'saída';

    const unidadeFormatada =
      productInfo.unidade === 'BR' ? 'Barras' :
        productInfo.unidade === 'UN' ? 'Unidades' :
          productInfo.unidade === 'PC' ? 'Peças' :
            productInfo.unidade === 'M' ? 'Metros' :
              `${productInfo.unidade} unidades`;

    const confirmacao = window.confirm(
      `Expedição Wolff: Deseja realmente realizar a ${operacao} de ${enteredQuantity} ${unidadeFormatada}?\n\nUsuário: ${usuarioSelecionado.DS_NOME}`
    );

    if (!confirmacao) return;

    // Marca como em processamento ANTES de qualquer operação assíncrona
    isSubmittingLocalEstoqueRef.current = true;
    setIsProcessingLocalEstoque(true);
    
    try {
      const payload = {
        tpEntradaSaida: tipo,
        idProduto: productInfo.idProduto,
        idProdutoVariante: productInfo.idProdutoVariante,
        quantity: enteredQuantity,
        idUsuario: usuarioSelecionado.ID_USUARIO,
      };
      
      console.log('📦 Enviando para Expedição Wolff:', payload);
      
      const response = await apiUploads.post('/faktory/stock/transferencia-local-estoque', payload);
      
      if (response.status === 200 || response.status === 201) {
        const data = response.data;
        
        // Verifica se houve falhas na finalização
        const finalizacao = data.finalizacao;
        if (finalizacao && finalizacao.falhas > 0) {
          const falhas = finalizacao.detalhes?.filter(d => !d.success) || [];
          const idsFalha = falhas.map(f => f.id).join(', ');
          
          alert(
            `⚠️ ATENÇÃO - FINALIZAÇÃO PENDENTE NO FAKTORY!\n\n` +
            `A transferência foi registrada na Expedição Wolff, porém NÃO FOI FINALIZADA automaticamente no Faktory.\n\n` +
            `IDs não finalizados: ${idsFalha || 'Verificar no Faktory'}\n\n` +
            `➡️ AÇÃO NECESSÁRIA: Acesse o Faktory e finalize manualmente a(s) transferência(s) pendente(s) em:\n` +
            `   Transferência de Local de Estoque`
          );
        } else {
          alert('✅ Expedição Wolff: Transferência realizada e finalizada com sucesso!');
        }
        
        setQuantidadeLocalEstoque('');
        setLocalEstoqueSelecionado('');
        setModalLocalEstoqueAberto(false);
        fetchProduct();
      }
    } catch (error) {
      console.error('Erro ao realizar transferência:', error);
      alert(
        `❌ ERRO NA EXPEDIÇÃO WOLFF!\n\n` +
        `${error.response?.data?.message || error.message}\n\n` +
        `⚠️ IMPORTANTE: Verifique no Faktory se a transferência foi registrada e finalize manualmente se necessário em:\n` +
        `   Transferência de Local de Estoque`
      );
    } finally {
      // Reseta o ref e o estado no finally para garantir que sempre seja executado
      isSubmittingLocalEstoqueRef.current = false;
      setIsProcessingLocalEstoque(false);
    }
  };







  const handleCodeChange = (e) => {
    setCode(e.target.value);
    setIsScanned(false);
  };

  const handleVariantChange = (e) => {
    setVariant(e.target.value);
    setIsScanned(false);
  };

  useEffect(() => {
    if (scanning) {
      startScanner();
    }
  }, [scanning, facingMode]);






  useEffect(() => {
    let touchStartY = 0;

    const handleTouchStart = (e) => {
      touchStartY = e.touches[0].clientY;
    };

    const handleTouchMove = (e) => {
      const currentY = e.touches[0].clientY;
      const diff = currentY - touchStartY;

      if (diff > 10 && window.scrollY === 0) {
        e.preventDefault(); // bloqueia o pull-to-refresh
      }
    };

    document.addEventListener('touchstart', handleTouchStart, { passive: false });
    document.addEventListener('touchmove', handleTouchMove, { passive: false });

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);


  return (
    <div className="FaktoryPage-container">
      <header className="header-container-landing-page">
        <div className="header-logo-center-landing-page">
          <label className="header-logo-center-label-landing-page">Syncs</label>
        </div>
        <div className="header-menu-right-landing-page">
          <button className="btn-voltar-header-faktory" onClick={() => navigate('/terminal')}>
            <MdArrowBack className="icon-voltar-header-faktory" />
          </button>
        </div>
      </header>

      <div className="FaktoryPage-content">
        {/* Indicador do modo Expedição Wolff */}
        {modoLocal && (
          <div className="StockLocationModal-mode-indicator">
            <span className="StockLocationModal-mode-indicator-icon">🚚</span>
            <span className="StockLocationModal-mode-indicator-text">Modo: Expedição Wolff</span>
          </div>
        )}

        {/* Exibir usuário selecionado */}
        {usuarioSelecionado && (
          <div className="FaktoryPage-usuario-card">
            <div className="FaktoryPage-usuario-card-content">
              <div className="FaktoryPage-usuario-card-icon">
                <MdPerson />
              </div>
              <div className="FaktoryPage-usuario-card-info">
                <p className="FaktoryPage-usuario-card-label">Usuário Ativo</p>
                <p className="FaktoryPage-usuario-card-name">{usuarioSelecionado.DS_NOME}</p>
                <p className="FaktoryPage-usuario-card-id">ID: {usuarioSelecionado.ID_USUARIO}</p>
              </div>
              <button
                className="FaktoryPage-usuario-card-button"
                onClick={handleAbrirModalUsuario}
              >
                <MdPerson />
                Trocar
              </button>
            </div>
          </div>
        )}

        {/* Botão para abrir modal se não houver usuário selecionado */}
        {!usuarioSelecionado && (
          <div className="FaktoryPage-usuario-empty">
            <button
              className="FaktoryPage-usuario-select-button"
              onClick={handleAbrirModalUsuario}
            >
              <MdPerson />
              <span>Selecionar Usuário</span>
            </button>
          </div>
        )}

        <h3 className="FaktoryPage-title">Localizar Produto:</h3>

        <div className="FaktoryPage-input-container">
          <div className="FaktoryPage-input-group">
            <label className="FaktoryPage-input-label" htmlFor="codigo">Código</label>
            <input
              id="codigo"
              className="FaktoryPage-input"
              type="text"
              value={code}
              onChange={handleCodeChange}
              placeholder="Inserir..."
              disabled={isProcessing}
            />
          </div>

          <div className="FaktoryPage-input-group">
            <label className="FaktoryPage-input-label" htmlFor="variante">Variante</label>
            <input
              id="variante"
              className="FaktoryPage-input"
              type="text"
              value={variant}
              onChange={handleVariantChange}
              placeholder="Inserir..."
              disabled={isProcessing}
            />
          </div>

          <div className="FaktoryPage-buttons-container">
            <button
              className="FaktoryPage-scan-button"
              onClick={fetchProduct}
              disabled={isProcessing}
            >
              <MdOutlineSearch className="FaktoryPage-icon" />
            </button>

            <button
              className="FaktoryPage-scan-button-scan"
              onClick={() => setScanning(true)}
              disabled={isProcessing}
            >
              <RiBarcodeBoxLine className="FaktoryPage-icon-scan" />
            </button>
          </div>
        </div>

        {productInfo && (
          <div className="FaktoryPage-input-container">
            <div className="FaktoryPage-input-group">
              <div className="FaktoryPage-product-info">
                <h4>Informações do Produto</h4>
                <p><strong>Código:</strong> {productInfo.code}</p>
                <p><strong>Nome:</strong> {productInfo.name}</p>
                <p><strong>Variante:</strong> {productInfo.variant}</p>
                <p><strong>Grupo:</strong> {productInfo.group}</p>
                <p><strong>Quantidade em Estoque:</strong> {productInfo.quantity}<strong>    {productInfo.unidade === 'BR' ? 'Barras' : productInfo.unidade === 'UN' ? 'Unidades' : productInfo.unidade === 'PC' ? 'Peças' : productInfo.unidade === 'M' ? 'Metros' : productInfo.unidade}</strong></p>
              </div>


            </div>


            {/* Modo normal: mostra todos os botões */}
            {!modoLocal && (
              <>
                <h3 className="FaktoryPage-title">Ajustar Estoque:</h3>

                <div className="FaktoryPage-input-container FaktoryPage-quantity-container">
                  <div className="FaktoryPage-input-group FaktoryPage-quantity-input-group">
                    <label className="FaktoryPage-input-label" htmlFor="quantidade">Quantidade</label>
                    <input
                      id="quantidade"
                      className="FaktoryPage-input"
                      type="number"
                      value={quantity}
                      onChange={(e) => setQuantity(e.target.value)}
                      placeholder="Quantidade..."
                      disabled={isProcessing}
                    />
                  </div>
                  <div className="FaktoryPage-buttons-container">
                    <button
                      className="FaktoryPage-update-button"
                      onClick={() => handleCodeSubmit(1)}
                      disabled={isProcessing}
                    >
                      Baixar
                    </button>
                    <button
                      className="FaktoryPage-update-button-entrar"
                      onClick={() => handleCodeSubmit(0)}
                      disabled={isProcessing}
                    >
                      Entrar
                    </button>
                  </div>

              {/* Botão para abrir modal Expedição Wolff */}
              <div className="FaktoryPage-buttons-container" style={{ marginTop: '12px' }}>
                <button
                  className="StockLocationModal-open-button"
                  onClick={handleAbrirModalLocalEstoque}
                  disabled={isProcessing}
                >
                  Expedição Wolff
                </button>
              </div>
                </div>
              </>
            )}

            {/* Modo Expedição Wolff: mostra apenas o botão de abrir modal */}
            {modoLocal && (
              <div className="FaktoryPage-input-container FaktoryPage-quantity-container">
                <div className="StockLocationModal-mode-info">
                  <p>Produto encontrado! Clique no botão abaixo para movimentar na Expedição Wolff.</p>
                </div>
                <div className="FaktoryPage-buttons-container">
                  <button
                    className="StockLocationModal-open-button"
                    onClick={handleAbrirModalLocalEstoque}
                    disabled={isProcessing}
                  >
                    Abrir Expedição Wolff
                  </button>
                </div>
              </div>
            )}












          </div>
        )}

        {scanning && (
          <div className="FaktoryPage-overlay">
            <div className="FaktoryPage-scanner-container">
              <div className="FaktoryPage-video-wrapper">
                <video className="FaktoryPage-video" ref={videoRef} autoPlay playsInline />
                <div className="FaktoryPage-scan-area"></div>
              </div>
              <div className="FaktoryPage-scanner-footer">
                <button className="FaktoryPage-toggle-button" onClick={toggleCamera}>
                  <MdAutorenew style={{ fontSize: '30px' }} />
                </button>
                <button onClick={stopCamera} className="FaktoryPage-cancel-button">Cancelar</button>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Seleção de Usuário */}
        {modalUsuarioAberto && (
          <div className="modal-usuario-overlay" onClick={handleFecharModalUsuario}>
            <div className="modal-usuario-container" onClick={(e) => e.stopPropagation()}>
              <div className="modal-usuario-header">
                <h2>Selecionar Usuário</h2>
                <button className="modal-usuario-close-btn" onClick={handleFecharModalUsuario}>
                  <MdClose />
                </button>
              </div>
              
              <div className="modal-usuario-content">
                <div className="modal-usuario-search-container">
                  <input
                    className="modal-usuario-search-input"
                    type="text"
                    value={buscaModalUsuario}
                    onChange={(e) => setBuscaModalUsuario(e.target.value)}
                    placeholder="Digite pelo menos 4 caracteres para buscar..."
                    disabled={buscandoUsuariosModal}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        handleBuscarUsuariosModal();
                      }
                    }}
                  />
                  <button
                    className="modal-usuario-search-button"
                    onClick={handleBuscarUsuariosModal}
                    disabled={buscandoUsuariosModal || !buscaModalUsuario || buscaModalUsuario.trim().length < 4}
                  >
                    <MdOutlineSearch />
                  </button>
                </div>

                {buscandoUsuariosModal && (
                  <div className="modal-usuario-loading">
                    <p>Buscando usuários...</p>
                  </div>
                )}

                {usuariosModal.length > 0 && (
                  <div className="modal-usuario-list">
                    {usuariosModal.map((usuario) => (
                      <div
                        key={usuario.ID_USUARIO}
                        className="modal-usuario-item"
                        onClick={() => handleSelecionarUsuario(usuario)}
                      >
                        <div className="modal-usuario-item-info">
                          <p className="modal-usuario-item-name">
                            <MdPerson style={{ marginRight: '8px', fontSize: '18px' }} />
                            {usuario.DS_NOME}
                          </p>
                          <p className="modal-usuario-item-id">ID: {usuario.ID_USUARIO}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {!buscandoUsuariosModal && usuariosModal.length === 0 && buscaModalUsuario.trim().length >= 4 && (
                  <div className="modal-usuario-empty">
                    <p>Nenhum usuário encontrado com esse termo.</p>
                  </div>
                )}

                {!buscandoUsuariosModal && usuariosModal.length === 0 && buscaModalUsuario.trim().length < 4 && (
                  <div className="modal-usuario-empty">
                    <p>Digite pelo menos 4 caracteres para buscar usuários.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Modal Expedição Wolff */}
        {modalLocalEstoqueAberto && (
          <div className="StockLocationModal-overlay" onClick={handleFecharModalLocalEstoque}>
            <div className="StockLocationModal-container" onClick={(e) => e.stopPropagation()}>
              <div className="StockLocationModal-header">
                <h2>Expedição Wolff</h2>
                <button className="StockLocationModal-close-btn" onClick={handleFecharModalLocalEstoque}>
                  <MdClose />
                </button>
              </div>
              
              <div className="StockLocationModal-content">
                {/* Aviso se não houver usuário selecionado */}
                {!usuarioSelecionado && (
                  <div className="StockLocationModal-warning">
                    <p>⚠️ Selecione um usuário antes de realizar a operação</p>
                  </div>
                )}

                {/* Informações do Usuário Selecionado */}
                {usuarioSelecionado && (
                  <div className="StockLocationModal-user-card">
                    <div className="StockLocationModal-user-icon">
                      <MdPerson />
                    </div>
                    <div className="StockLocationModal-user-info">
                      <span className="StockLocationModal-user-label">Usuário</span>
                      <span className="StockLocationModal-user-name">{usuarioSelecionado.DS_NOME}</span>
                    </div>
                  </div>
                )}

                {/* Informações do Produto Selecionado */}
                {productInfo && (
                  <div className="StockLocationModal-product-card">
                    <div className="StockLocationModal-product-header">
                      <span className="StockLocationModal-product-label">Produto Selecionado</span>
                    </div>
                    <div className="StockLocationModal-product-details">
                      <p><strong>Código:</strong> {productInfo.code}</p>
                      <p><strong>Nome:</strong> {productInfo.name}</p>
                      <p><strong>Variante:</strong> {productInfo.variant}</p>
                      <p><strong>Estoque Atual:</strong> {productInfo.quantity} {productInfo.unidade === 'BR' ? 'Barras' : productInfo.unidade === 'UN' ? 'Unidades' : productInfo.unidade === 'PC' ? 'Peças' : productInfo.unidade === 'M' ? 'Metros' : productInfo.unidade}</p>
                    </div>
                  </div>
                )}

                {/* Campo de Quantidade */}
                <div className="StockLocationModal-field-group">
                  <label className="StockLocationModal-field-label" htmlFor="quantidadeLocal">
                    Quantidade
                  </label>
                  <input
                    id="quantidadeLocal"
                    className="StockLocationModal-input"
                    type="number"
                    value={quantidadeLocalEstoque}
                    onChange={(e) => setQuantidadeLocalEstoque(e.target.value)}
                    placeholder="Digite a quantidade..."
                    disabled={isProcessingLocalEstoque}
                    min="1"
                  />
                </div>

                {/* Botões de Ação */}
                <div className="StockLocationModal-actions">
                  <button
                    className="StockLocationModal-btn-baixar"
                    onClick={() => handleSubmitLocalEstoque(1)}
                    disabled={isProcessingLocalEstoque || !usuarioSelecionado || !quantidadeLocalEstoque}
                  >
                    {isProcessingLocalEstoque ? 'Processando...' : 'Baixar'}
                  </button>
                  <button
                    className="StockLocationModal-btn-entrar"
                    onClick={() => handleSubmitLocalEstoque(0)}
                    disabled={isProcessingLocalEstoque || !usuarioSelecionado || !quantidadeLocalEstoque}
                  >
                    {isProcessingLocalEstoque ? 'Processando...' : 'Entrar'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default FaktoryPage;